<template>
  <div class="report-no-data">
    <img
      class="img-responsive center-block"
      :src="IMAGE_NO_REPORT_DATA"
      alt="No report data"
    />
    <h4 class="text-muted text-center">{{ errorMessage }}</h4>
    <h5 class="text-muted text-center">{{ helpText }}</h5>
  </div>
</template>

<script>
import { IMAGE_NO_REPORT_DATA } from '~/rails_assets';

export default {
  props: {
    hasFilters: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      IMAGE_NO_REPORT_DATA,
    };
  },
  computed: {
    errorMessage() {
      if (this.hasFilters) {
        return 'Nothing matches the current filters';
      }

      return 'Nothing to report';
    },
    helpText() {
      if (this.hasFilters) {
        return 'Try changing or removing some filters to see something.';
      }

      return 'Expecting to see something? Try adjusting the report.';
    },
  },
};
</script>
